import React from "react";

import { useTranslation } from "react-i18next";

import { useToast } from "hooks/toast";

import { Container, ButtonContainer, Overlay } from "./styles";

interface IModalSelectOrTakePicture {
  takePicture: () => void;
  onClose: () => void;
  setFileImg: (file: File) => void;
  preview: string;
}

const ModalSelectOrTakePicture: React.FC<IModalSelectOrTakePicture> = ({
  takePicture,
  setFileImg,
  onClose,
  preview,
}) => {
  const { t } = useTranslation();
  const { addToast } = useToast();

  const ALLOWED_IMAGE_TYPES = ["image/png", "image/jpeg"];

  const isAllowedImageType = (image: File) => {
    return ALLOWED_IMAGE_TYPES.includes(image.type);
  };

  return (
    <>
      <Overlay onClick={onClose} />
      <Container>
        <ButtonContainer onClick={takePicture}>
          <span>{preview ? t("camera.removePhoto") : t("camera.takePhoto")}</span>
        </ButtonContainer>
        <ButtonContainer>
          <label htmlFor="upload">{t("camera.uploadFromComputer")}</label>
          <input
            id="upload"
            onChange={(e) => {
              onClose();
              const file = e.target.files?.[0];
              if (file && !isAllowedImageType(file)) {
                addToast({
                  type: "error",
                  title: t("camera.photo"),
                  description: t("camera.invalidImageFormat"),
                });
              } else if (file && file.size < 500000) {
                setFileImg(file);
              } else {
                addToast({
                  type: "warning",
                  title: t("camera.photo"),
                  description: t("camera.photoSizeLimit"),
                });
              }
            }}
            accept="image/png, image/jpeg"
            type="file"
          />
        </ButtonContainer>
      </Container>
    </>
  );
};

export default ModalSelectOrTakePicture;
